import React from 'react';
import './ListItem.css';
import { setTask } from './TaskDetails.js';
import { getTasks, sortList } from './List';
import { renderList } from './filter';

function editTask(taskId) {
    // find task object in tasks array
    var tasks = getTasks();
    var task;
    for (var i = 0; i < tasks.length; i++) {
        if (tasks[i].id === taskId) {
            task = tasks[i];
            break;
        }
    }
    console.log(task);
    // set task details
    setTask(task);

}




class ListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            title: this.props.title,
            date: this.props.date,
            time: this.props.time,
            location: this.props.location,
            description: this.props.description,
            selected: this.props.selected,
            class: "list-item"
        }
        if (this.props.selected) {
            this.state.class += " item-selected";
        }
    }

    selectItem() {
        // check if the item is already selected
        var tasks = getTasks();
        var task;
        for (var i = 0; i < tasks.length; i++) {
            if (tasks[i].id === this.props.id) {
                task = tasks[i];
                break;
            }
        }
        if (this.state.class.includes("item-selected")) {
            task.selected = false;
            tasks[i] = task;
            tasks = sortList(tasks);
            localStorage.setItem("tasks", JSON.stringify(tasks));
            this.setState({ class: this.state.class.replace(" item-selected", "") }, () => {
                this.setState({ selected: false }, () => {
                    this.props.reRender();
                });
            }, () => {
                renderList();
            });
            // add selected: true to the task object
        } else {
            task.selected = true;
            tasks[i] = task;
            tasks = sortList(tasks);
            localStorage.setItem("tasks", JSON.stringify(tasks));
            this.setState({ class: this.state.class + " item-selected" }, () => {
                this.setState({ selected: true }, () => {
                    this.props.reRender();
                });
            }, () => {
                renderList();
            });
            // change key of the list item

            // add selected: true to the task object
            // Q: how to update the state of the parent component?
            // A: pass a function as a prop to the child component

        }
    }

    render() {
        return (
            <div id="list-item" className={this.state.class} onClick={(event) => {
                if (event.target !== event.currentTarget) return;
                editTask(this.props.id);
            }}>
                <span id="list-item-crossed"></span>
                <label id="list-item-container" className='container'>
                    <input type="checkbox" id="list-item-checkbox" checked={this.state.selected} onChange={renderList} />
                    <span id="list-item-checkmark" className='checkmark' onClick={() => this.selectItem()} ></span>
                </label>
                <div id="list-item-row1" className='list-item-row1' onClick={() => editTask(this.props.id)} >
                    <div id="list-item-row2">
                        <div id="list-item-title">
                            {this.props.title}
                        </div>
                        <div id="list-item-details">
                            <div id="list-item-date">{this.props.date} @ {this.props.time}</div>
                            <div id="list-item-location">{this.props.location}</div>
                        </div>
                    </div>

                    <i id="list-item-id" style={{ display: 'none' }}>{this.props.id}</i>
                    <div id="list-item-row3">
                        <div id="list-item-description">{this.props.description}</div>
                        <div id="list-item-category">
                            <div id="list-item-category-color" style={{ backgroundColor: this.props.categoryColor }}></div>
                            <h4 id="list-item-category-name">{this.props.category}</h4>
                        </div>
                    </div>
                </div>
                {/* <button id="list-item-delete" onClick={this.props.onDelete}>X</button> */}
            </div>

        );
    }
}
export default ListItem;